// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import Highcharts from "highcharts"
import Chartkick from "chartkick"
Chartkick.use(Highcharts)

window.CKEDITOR_GLOBAL_LICENSE_KEY = "GPL"
